/**
 * Client initialization file.
 * Sets up error handling interceptors on the generated API client
 * to ensure all errors are normalized to Error instances with stack traces.
 * This file should be imported early in the application lifecycle.
 */
import { client } from '@/api/generated/client.gen';

import { setupClientErrorHandling } from './api-client';

// Set up error handling to normalize all errors to Error instances with stack traces
// This ensures PostHog can capture proper stack traces for all API errors
setupClientErrorHandling(client);
